import { useLogout } from '@/features/auth';
import { PowerSettingsNew, Settings } from '@mui/icons-material';
import { Avatar, Box, Divider, ListItemIcon, ListItemText, Menu, MenuItem, Typography } from '@mui/material';
import { red } from '@mui/material/colors';
import { Link } from 'react-router-dom';

type Props = {
    anchorEl: HTMLElement | null;
    open: boolean;
    handleClose: () => void;
    prfName: string;
    email: string;
};

export const UserMenuNavbar = ({ anchorEl, open, handleClose, prfName, email }: Props) => {
    const { mutate: logoutUser } = useLogout();

    const logOut = () => {
        logoutUser();
    };
    return (
        <Menu
            anchorEl={anchorEl}
            id="account-menu"
            open={open}
            onClose={handleClose}
            onClick={handleClose}
            PaperProps={{
                elevation: 8,
                sx: {
                    mt: 1.5,
                    minWidth: 240,
                    borderRadius: 2,
                    overflow: 'visible',
                    filter: 'drop-shadow(0px 4px 12px rgba(0, 0, 0, 0.15))',
                    border: '1px solid rgba(0, 0, 0, 0.05)',
                    '& .MuiMenuItem-root': {
                        px: 2,
                        py: 1.5,
                        fontSize: '0.875rem',
                        '&:hover': {
                            backgroundColor: 'rgba(0, 0, 0, 0.04)',
                        },
                    },
                    '&:before': {
                        content: '""',
                        display: 'block',
                        position: 'absolute',
                        top: 0,
                        right: 20,
                        width: 12,
                        height: 12,
                        bgcolor: 'background.paper',
                        transform: 'translateY(-50%) rotate(45deg)',
                        borderLeft: '1px solid rgba(0, 0, 0, 0.05)',
                        borderTop: '1px solid rgba(0, 0, 0, 0.05)',
                        zIndex: 0,
                    },
                },
            }}
            transformOrigin={{ horizontal: 'right', vertical: 'top' }}
            anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        >
            <MenuItem
                component={Link}
                to="/settings"
                onClick={handleClose}
                sx={{
                    py: 2,
                    '&:hover': {
                        backgroundColor: 'rgba(120, 117, 255, 0.08)',
                    },
                }}
            >
                <Avatar
                    sx={{
                        width: 40,
                        height: 40,
                        mr: 2,
                        fontSize: '1rem',
                        fontWeight: 600,
                        color: 'var(--color-primary)',
                        backgroundColor: 'rgba(120, 117, 255, 0.1)',
                        border: '2px solid rgba(120, 117, 255, 0.2)',
                    }}
                >
                    {prfName.charAt(0).toUpperCase()}
                </Avatar>
                <Box sx={{ flex: 1, minWidth: 0 }}>
                    <Typography variant="body2" sx={{ fontWeight: 600, color: 'var(--color-text-dark)' }}>
                        {prfName}
                    </Typography>
                    {email && (
                        <Typography variant="caption" sx={{ color: 'var(--color-text-gray-medium)', display: 'block' }}>
                            {email}
                        </Typography>
                    )}
                </Box>
            </MenuItem>

            <Divider sx={{ my: 0.5 }} />

            <MenuItem
                component={Link}
                to="/settings"
                onClick={handleClose}
                sx={{
                    color: 'var(--color-text-gray)',
                    '&:hover': {
                        backgroundColor: 'rgba(120, 117, 255, 0.08)',
                    },
                }}
            >
                <ListItemIcon>
                    <Settings sx={{ color: 'var(--color-text-gray-medium)', fontSize: '1.25rem' }} />
                </ListItemIcon>
                <ListItemText primary="Settings" />
            </MenuItem>

            <Divider sx={{ my: 0.5 }} />

            <MenuItem
                onClick={() => {
                    handleClose();
                    logOut();
                }}
                sx={{
                    color: red[600],
                    '&:hover': {
                        backgroundColor: 'rgba(211, 47, 47, 0.08)',
                    },
                }}
            >
                <ListItemIcon>
                    <PowerSettingsNew sx={{ color: red[600], fontSize: '1.25rem' }} />
                </ListItemIcon>
                <ListItemText primary="Logout" />
            </MenuItem>
        </Menu>
    );
};

